<template>
  <div class="app-container">
    <div class="app-main">
      <div class="title">{{ dataInfo.title }}</div>
      <div class="desc-box">
        <span class="author">作者：{{ dataInfo.author }}</span>
        <span class="time">发表时间：{{ dataInfo.publishTime }}</span>
      </div>
      <div class="html-box">
        <p class="rich-text" v-html="dataInfo.content"></p>
      </div>
    </div>
  </div>
</template>
<script>
import { getNoticeView } from "@/api/announcementcenter";
export default {
  name: "AnnouncementCenterDetail",
  data() {
    return {
      id: "",
      dataInfo: {},
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this._getNoticeView();
    }
  },
  methods: {
    _getNoticeView() {
      getNoticeView({ id: this.id })
        .then((res) => {
          const { data } = res;
          this.dataInfo = { ...data };
          const regex = new RegExp("<img", "gi");
          this.dataInfo.content = this.dataInfo.content.replace(
            regex,
            `<img class="rich-content"`
          );
        })
        .catch((res) => {})
        .finally(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  background-color: #f6fafe;
  padding-top: 50px;
  padding-bottom: 120px;
  .app-main {
    width: 1320px;
    background-color: #ffffff;
    border-radius: 12px;
    margin: 0 auto;
    padding: 26px 32px 48px;
    text-align: left;
    .title {
      color: #666666;
      font-size: 24px;
    }
    .desc-box {
      font-size: 14px;
      color: #999999;
      margin-top: 10px;
      padding-bottom: 19px;
      border-bottom: 1px solid #cccccc;
      .time {
        padding-left: 20px;
      }
    }
    .html-box {
      margin-top: 30px;
      .rich-text {
        width: 100%;
        height: auto;
      }
    }
  }
}
/deep/ .rich-text .rich-content {
  max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/announcementcenter/detail.vue